import moment from "moment";
import printer from "@/service/printer";
import {
  contributoVerdeBlu,
  contributoFatturatoPeriodo,
  contributoTotale,
} from "./verdeBluUtility";
export default {
  mounted() {
    window.addEventListener("focus", this.refreshList);
    window.addEventListener("mousemove", this.resetInactivityTimer);
    window.addEventListener("keydown", this.resetInactivityTimer);
    window.addEventListener("touchstart", this.resetInactivityTimer);
    this.$store
      .dispatch("fetch_contabili", {
        inizio: this.getInizioTs(),
        fine: moment().format("X"),
      })
      .then(() => {
        this.loading = false;
        this.refreshList();
      });
    this.fetchApertureRiepilogo();
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.refreshList);
    window.removeEventListener("mousemove", this.resetInactivityTimer);
    window.removeEventListener("keydown", this.resetInactivityTimer);
    window.removeEventListener("touchstart", this.resetInactivityTimer);
  },
  data() {
    return {
      loading: true,
      dialog: false,
      soloNonSaldati: true,
      raggruppaPerCliente: false,
      cliente: null,
      contabili: [],
      // Riepilogo per cliente di quanto ancora aperto/disponibile, SENZA
      // vincolo di periodo (round 65-octodecies) — vedi fetchApertureRiepilogo.
      apertureRiepilogo: {},
      periodoItems: [
        { nome: "Inizio Anno", value: "anno" },
        { nome: "Ultimi 30 giorni", value: 30 },
        { nome: "Ultimi 60 giorni", value: 60 },
        { nome: "Ultimi 90 giorni", value: 90 },
        { nome: "Ultimi 180 giorni", value: 180 },
        { nome: "Ultimo Anno", value: 360 },
        { nome: "Tutti", value: 9999 },
      ],
      periodo: "anno",
      tipoItems: [
        { nome: "Entrambi", value: 0 },
        { nome: "Solo Verde", value: 1 },
        { nome: "Solo Blu", value: 2 },
      ],
      tipo: 0,
      dialogInattivita: false,
      inactivityTimer: null,
    };
  },
  watch: {
    // true = filtro applicato "pulito" (un elemento appena diventato
    // saldato può sparire subito): l'utente ha appena chiesto lui stesso
    // una vista diversa, è quello che si aspetta. Cambia solo qui, in
    // risposta a un controllo di filtro toccato direttamente — ogni altro
    // richiamo di refreshList() (dopo un'azione, al ritorno di focus
    // sulla finestra, dopo l'avviso di inattività) resta di default
    // "conservativo" — vedi refreshList().
    soloNonSaldati() {
      this.refreshList(true);
    },
    cliente(valore) {
      if (valore) {
        // Con un cliente specifico selezionato, il raggruppamento è quasi
        // sempre quello che si vuole vedere (la lista piatta ha senso
        // soprattutto su più clienti insieme) — attivalo automaticamente,
        // resta comunque disattivabile a mano.
        this.raggruppaPerCliente = true;
      }
      this.refreshList(true);
    },
    tipo() {
      this.refreshList(true);
    },
    periodo() {
      this.$store
        .dispatch("fetch_contabili", {
          inizio: this.getInizioTs(),
          fine: moment().format("X"),
        })
        .then(() => {
          this.loading = false;
          this.refreshList(true);
        });
    },
  },
  computed: {
    groupedByCliente() {
      let grouped = {};
      this.contabili.forEach((contabile) => {
        if (!grouped[contabile.cliente]) {
          grouped[contabile.cliente] = {
            contabili: {},
            totale: 0,
            tot_blu: 0,
            tot_verde: 0,
            // Quanto il cliente deve davvero adesso e quanto credito ha
            // ancora disponibile: NON dipendono dal periodo/filtro qui
            // selezionato (round 65-octodecies) — un debito o un credito
            // aperti restano tali indipendentemente da quando sono nati,
            // filtrarli per periodo li faceva sparire silenziosamente se
            // più vecchi della finestra scelta. Valorizzati sotto, fuori
            // da questo forEach, da apertureRiepilogo (fetch separato,
            // senza vincolo di ts — vedi fetchApertureRiepilogo).
            residuoAperto: 0,
            residuoApertoVerde: 0,
            residuoApertoBlu: 0,
            countAperti: 0,
            creditoDisponibile: 0,
            countCrediti: 0,
          };
        }
        const month = moment(contabile.ts * 1000).format("MMMM YY");
        if (!grouped[contabile.cliente].contabili[month]) {
          grouped[contabile.cliente].contabili[month] = {
            contabili: [],
            totale: 0,
            tot_blu: 0,
            tot_verde: 0,
          };
        }
        // "Totale" (mese e cumulativo): sempre indipendente dai Pagamenti
        // Cliente, in qualunque modalità di "Solo Non Saldati" — un
        // incasso non è fatturato. "Quanto ancora scoperto" è delegato al
        // chip residuoAperto, non a questo numero (vedi contributoTotale).
        // Il verde/blu invece resta diverso tra i due livelli: a mese
        // niente riclassificazione (contributoFatturatoPeriodo, un
        // singolo mese non è il posto giusto per spostare l'imponibile di
        // una fattura da verde a blu — round 29); a livello cliente
        // (cumulativo sull'intero periodo) la riclassificazione piena
        // resta corretta (contributoVerdeBlu, round 28).
        const fatturato = contributoFatturatoPeriodo(contabile);
        const cumulativo = contributoVerdeBlu(contabile);
        const totale = contributoTotale(contabile);
        grouped[contabile.cliente].contabili[month].contabili.push(contabile);
        grouped[contabile.cliente].contabili[month].totale += totale;
        grouped[contabile.cliente].contabili[month].tot_verde += fatturato.verde;
        grouped[contabile.cliente].contabili[month].tot_blu += fatturato.blu;
        grouped[contabile.cliente].totale += totale;
        grouped[contabile.cliente].tot_verde += cumulativo.verde;
        grouped[contabile.cliente].tot_blu += cumulativo.blu;
      });

      // Quanto ancora aperto/disponibile per ciascun cliente già presente
      // in questa vista (con almeno un movimento nel periodo/filtro
      // selezionato) — sempre l'importo VERO, all-time, non quello del
      // solo periodo qui mostrato (round 65-octodecies). Un cliente senza
      // alcun movimento in questo periodo non compare comunque in
      // `grouped` (la lista dei movimenti resta legata al periodo, per
      // design): questo aggiornamento riguarda solo il chip di un cliente
      // già altrimenti visibile.
      Object.keys(grouped).forEach((cliente) => {
        const riepilogo = this.apertureRiepilogo[cliente];
        if (!riepilogo) return;
        grouped[cliente].residuoAperto = riepilogo.residuo_aperto || 0;
        grouped[cliente].residuoApertoVerde = riepilogo.residuo_aperto_verde || 0;
        grouped[cliente].residuoApertoBlu = riepilogo.residuo_aperto_blu || 0;
        grouped[cliente].countAperti = riepilogo.count_aperti || 0;
        grouped[cliente].creditoDisponibile = riepilogo.credito_disponibile || 0;
        grouped[cliente].countCrediti = riepilogo.count_crediti || 0;
      });

      // Ordina le contabili di ogni mese per il numero prima dello slash nel ddt
      Object.keys(grouped).forEach((cliente) => {
        Object.keys(grouped[cliente].contabili).forEach((month) => {
          grouped[cliente].contabili[month].contabili.sort((a, b) => {
            const numA = parseInt((a.ddt || "").split("/")[0], 10);
            const numB = parseInt((b.ddt || "").split("/")[0], 10);
            return numA - numB;
          });
        });
      });

      return grouped;
    },
    groupedByDay() {
      let grouped = {};
      this.contabili.forEach((contabile) => {
        const day = moment(contabile.ts * 1000).format("dddd DD MMMM YYYY");
        if (!grouped[day]) {
          grouped[day] = {
            contabili: [],
            totale: 0,
            tot_verde: 0,
            tot_blu: 0,
          };
        }
        // Il record resta comunque visibile nell'elenco del giorno, ma
        // solo un Debito (consegna/DDT) contribuisce al "Tot Giorno": un
        // Pagamento Cliente o una Fattura Anticipata seguono un proprio
        // calendario indipendente da quando la merce è stata consegnata,
        // e sommarli confonderebbe lo sguardo veloce che questo totale
        // serve a dare ("quanto ho consegnato/fatturato oggi").
        grouped[day].contabili.push(contabile);
        if (contabile.tipo === 1) {
          grouped[day].totale += contabile.importo;
          grouped[day].tot_verde += contabile.verde ? contabile.importo : 0;
          grouped[day].tot_blu += !contabile.verde ? contabile.importo : 0;
        }
      });

      // Ordina le contabili di ogni giorno per il numero prima dello slash nel ddt
      Object.keys(grouped).forEach((day) => {
        grouped[day].contabili.sort((a, b) => {
          // Estrai il numero prima dello slash
          const numA = parseInt((a.ddt || "").split("/")[0], 10);
          const numB = parseInt((b.ddt || "").split("/")[0], 10);
          return numA - numB;
        });
      });

      return grouped;
    },
    clienti() {
      return this.$store.getters.get_clienti;
    },
  },
  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.dialogInattivita = true;
      }, 60000); // 1 minuto di inattività
    },
    continua_navigazione() {
      this.dialogInattivita = false;
      this.resetInactivityTimer();
      this.refreshList();
    },
    // `filtroPulito` (round 65-terdecies): di default false, per non far
    // sparire di scatto un elemento appena diventato saldato con "Solo
    // Non Saldati" attivo — sia dallo shortcut rapido in lista sia,
    // soprattutto, dal dialog "Copertura debito"/"Erosione credito"
    // (dove sparire sotto l'utente mentre sta ancora guardando il
    // risultato della sua azione è particolarmente spaesante). Un
    // elemento già presente in `this.contabili` prima di questa chiamata
    // resta visibile (con lo stato aggiornato) anche se non supera più il
    // filtro, finché non arriva un refresh esplicito — cambio di
    // soloNonSaldati/cliente/tipo/periodo (unici punti che passano
    // `true`) o un vero cambio pagina (che riparte da `this.contabili`
    // vuoto, quindi non c'è nulla da "ripescare").
    async refreshList(filtroPulito = false) {
      let array = [...this.$store.getters.get_contabili].sort((a, b) => {
        return b.ts - a.ts;
      });

      // Prefetch in un'unica richiesta batch il numero di tutti gli ordini
      // referenziati dal periodo corrente, cache-aware: se sono già tutti
      // noti risolve subito senza rete. Così, quando le righe montano,
      // ContabileOrdineRef trova il valore già in cache invece di fare
      // una richiesta HTTP separata per ognuna (pattern N+1).
      const idsOrdine = array.map((contabile) => contabile.id_ordine);
      try {
        await this.$store.dispatch("fetch_ordini_numeri", idsOrdine);
      } catch (e) {
        // Il batch è solo un'ottimizzazione: se fallisce, le singole righe
        // ricadono comunque sul fetch individuale già esistente.
      }

      if (this.tipo == 1) {
        array = array.filter((contabile) => {
          return contabile.verde == true;
        });
      } else if (this.tipo == 2) {
        array = array.filter((contabile) => {
          return contabile.verde == false;
        });
      }
      if (this.cliente) {
        array = array.filter((contabile) => {
          return contabile.cliente == this.cliente;
        });
      }
      if (!this.soloNonSaldati) {
        this.contabili = array;
        return;
      }
      const filtrati = array.filter((contabile) => !contabile.saldato);
      if (filtroPulito) {
        this.contabili = filtrati;
        return;
      }
      // Ripesca gli elementi già visibili prima di questa chiamata che
      // ora non superano più il filtro (appena diventati saldato) — solo
      // quelli, non tutti i saldati del periodo: un elemento MAI apparso
      // in questa sessione resta correttamente filtrato.
      const idsGiaVisibili = new Set(this.contabili.map((contabile) => contabile.id));
      const idsFiltrati = new Set(filtrati.map((contabile) => contabile.id));
      const daRipescare = array.filter(
        (contabile) => idsGiaVisibili.has(contabile.id) && !idsFiltrati.has(contabile.id)
      );
      this.contabili = [...filtrati, ...daRipescare].sort((a, b) => b.ts - a.ts);
    },
    // Come refreshList(), ma prima ri-scarica la lista dal server invece di
    // rileggere solo la cache locale dello store. Usato dopo creazione,
    // eliminazione, modifica e allocazioni (azioni poco frequenti, non il
    // click sulla checkbox saldato) per garantire che dati derivati come il
    // "residuo" di un credito erodibile siano sempre corretti in lista,
    // senza dover indagare ulteriormente su eventuali sottigliezze di
    // propagazione dei prop attraverso v-lazy/v-for.
    hardRefreshList() {
      this.fetchApertureRiepilogo();
      return this.$store
        .dispatch("fetch_contabili", {
          inizio: this.getInizioTs(),
          fine: moment().format("X"),
        })
        .then(() => {
          this.refreshList();
        });
    },
    // Round 65-octodecies: quanto un cliente ha ancora aperto/disponibile
    // NON dipende dal periodo visualizzato (un debito vecchio di mesi
    // resta dovuto, un credito vecchio resta erodibile) — richiesto a
    // parte dalla lista dei movimenti, che invece resta legata al
    // periodo. Fallisce in silenzio: è un arricchimento del chip, non
    // deve bloccare il caricamento della lista principale se non va a
    // buon fine.
    fetchApertureRiepilogo() {
      return this.$store
        .dispatch("fetch_aperture_riepilogo")
        .then((data) => {
          this.apertureRiepilogo = data || {};
        })
        .catch(() => {});
    },
    getCliente(iva) {
      return this.$store.getters.get_cliente_by_iva(iva);
    },
    stampaEstrattoContoCliente(iva) {
      const coloreMap = { 1: 'verde', 2: 'blu' };
      printer.print_estratto_conto(iva, this.getInizioTs(), moment().format("X"), coloreMap[this.tipo] || null);
    },
    getInizioTs() {
      if (this.periodo === "anno") {
        return moment().startOf("year").format("X");
      }
      if (this.periodo === 9999) {
        return moment("2000-01-01").format("X");
      }
      return moment().subtract(this.periodo, "days").format("X");
    },
  },
};
